var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadCloudBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 317 237"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2FA",
  d: "M254.031 84.461c24.296 3.5 42.969 24.45 42.969 49.773 0 27.772-22.461 50.286-50.168 50.286-3.634 0-7.178-.387-10.593-1.123-9.231 19.971-29.406 33.824-52.809 33.824-16.614 0-31.6-6.981-42.2-18.176a52.3 52.3 0 0 1-31.051 10.155c-27.18 0-49.546-20.65-52.337-47.152C35.974 155.643 20 135.393 20 111.404 20 82.269 43.563 58.65 72.63 58.65q.433 0 .864.007c8.958-22.768 31.101-38.878 56.998-38.878 20.904 0 39.362 10.497 50.414 26.52a53 53 0 0 1 20.991-4.308c25.679 0 47.113 18.222 52.134 42.47"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 10.125,
  d: "M302.063 134.234c0-26.664-18.813-48.929-43.88-54.178-6.712-24.84-29.357-43.128-56.286-43.128a58.1 58.1 0 0 0-19.212 3.248c-12.131-15.49-30.998-25.46-52.193-25.46-26.837 0-49.932 15.974-60.37 38.925-30.709 1.316-55.185 26.685-55.185 57.763 0 25.118 15.982 46.493 38.314 54.473 4.494 27.439 28.26 48.386 56.928 48.386a57.36 57.36 0 0 0 30.451-8.701c11.256 10.376 26.291 16.722 42.8 16.722 24.054 0 44.955-13.458 55.643-33.244 2.537.358 5.128.543 7.759.543 30.514 0 55.231-24.792 55.231-55.349Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 316.055,
  height: 236.497,
  x: 0.473,
  y: 0.251,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.701
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.211765 0 0 0 0 0.254902 0 0 0 0 0.321569 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  mode: "normal",
  result: "effect1_dropShadow_3264_5045"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_3264_5045",
  mode: "normal",
  result: "shape"
})))));
export default SvgUploadCloudBox;